{
  "components": {
    "AddRoomForm": {
      "add_room": "Add Room",
      "room_name": "Room name",
      "room_category": "Room category",
      "select_room_category": "Select room category",
      "room_code": "Room code",
      "attrs": {
        "enter_room_code": "Enter room code",
        "enter_room_description": "Enter room description"
      },
      "description": "Description",
      "smoking": "Smoking",
      "accessibility": "Accessibility",
      "status": "Status",
      "room_view": "Room view",
      "select_room_view": "Select room view",
      "room_size_sq_m": "Room size (sq m)",
      "room_amenities": "Room amenities",
      "occupancy_settings": "Occupancy Settings",
      "base_adults_occupancy": "Base Adults Occupancy",
      "standard_number_of_allowed_adults_for": "Standard number of allowed adults for this room",
      "base_children_occupancy": "Base Children Occupancy",
      "standard_number_of_allowed_children_for": "Standard number of allowed children for this room",
      "maximum_occupancy": "Maximum Occupancy",
      "maximum_number_of_guests_allowed": "Maximum number of guests allowed",
      "allow_additional_adults": "Allow additional adults",
      "allow_additional_adults_not_exceeding_total": "Allow additional adults (not exceeding total occupancy limit)",
      "allow_additional_children": "Allow additional children",
      "allow_additional_children_not_exceeding_total": "Allow additional children (not exceeding total occupancy limit)",
      "this_room_has_a_base_occupancy": "This room has a base occupancy of",
      "adults_and": "Adults and",
      "children_with_a_total_maximum_occupancy": "Children with a total maximum\n                  occupancy of",
      "additional_adults_are_not_allowed": "Additional adults are not allowed.",
      "additional_children_are_not_allowed": "Additional children are not allowed.",
      "additional_cost_per_child_or_adults": "Additional cost per child or adults on top of the base\n                  occupancy can be configured in rates.",
      "bed_configuration": "Bed configuration",
      "bed_type": "Bed type",
      "select_bed_type": "Select bed type",
      "bed_count": "Bed count",
      "add_bed_configuration": "Add bed configuration",
      "save": "Save"
    },
    "EditRoomForm": {
      "edit_room": "Edit Room",
      "room_information": "Room information",
      "media_assets": "Media assets",
      "children_with_a_total_maximum_occupancy": "Children with a total\n                    maximum occupancy of",
      "additional_cost_per_child_or_adults": "Additional cost per child or adults on top of the base\n                    occupancy can be configured in rates."
    },
    "RoomAssets": {
      "room_assets": "Room Assets",
      "drag_files_here": "Drag files here",
      "supported_formats_png_jpg_jpeg": "Supported formats: PNG, JPG, JPEG",
      "max_file_size_10mb": "Max file size: 10MB",
      "upload": "Upload",
      "room_image": "Room image",
      "caption": "Caption",
      "uploaded_by": "Uploaded by",
      "uploaded": "Uploaded",
      "visibility": "Visibility",
      "actions": "Actions"
    }
  },
  "pages": {
    "PropertyInformation": {
      "hotel": "Hotel",
      "hotel_information": "Hotel Information",
      "draft_submitted_for_review": "Draft: Submitted for review",
      "draft_status": "Draft Status",
      "hotel_name": "Hotel name",
      "designation": "Designation",
      "resort": "Resort",
      "villa": "Villa",
      "guesthouse": "Guesthouse",
      "star_rating": "Star rating",
      "tags": "Tags",
      "address": "Address",
      "area_name": "Area name",
      "city": "City",
      "postal_code": "Postal code",
      "country": "Country",
      "thailand": "Malaysia",
      "malaysia": "Malaysia",
      "indonesia": "Indonesia",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "contact_email": "Contact Email",
      "phone_number": "Phone number",
      "website": "Website",
      "timezone": "Timezone",
      "asiabangkok": "Asia/Kuala_Lumpur",
      "asiakualalumpur": "Asia/Kuala_Lumpur",
      "asiasingapore": "Asia/Singapore",
      "checkin_time": "Check-in Time",
      "checkout_time": "Check-out Time",
      "hotel_amenities": "Hotel Amenities",
      "transportation": "Transportation"
    },
    "Rates": {
      "rates": "Rates",
      "add_rates": "Add Rates",
      "attrs": {
        "search_rates": "Search rates..."
      },
      "active": "Active",
      "inactive": "Inactive",
      "room_type": "Room Type",
      "deluxe": "Deluxe",
      "superior": "Superior",
      "overwater_villa": "Overwater Villa",
      "details": "Details",
      "promo_code": "Promo Code",
      "base_nightly_rate": "Base Nightly Rate",
      "cancellation_plan": "Cancellation Plan",
      "promo": "PROMO"
    },
    "ReservationDetail": {
      "reservation_details": "Reservation Details",
      "confirmed": "Confirmed",
      "resend_confirmation_email": "Resend confirmation email",
      "date": "Date",
      "nights": "Nights",
      "guests_rooms": "Guests & Rooms",
      "adults": "Adults,",
      "children": "Children,",
      "infants": "Infants",
      "room": "Room",
      "booking_information": "Booking Information",
      "booking_id": "Booking ID",
      "transaction_id": "Transaction ID",
      "name": "Name",
      "hotel_id": "Hotel ID",
      "view": "View",
      "category": "Category",
      "guest_information": "Guest Information",
      "email": "Email",
      "passport_number": "Passport number",
      "date_of_birth": "Date of birth",
      "nationality": "Nationality",
      "special_requests": "Special Requests",
      "rate_details": "Rate Details",
      "rate_name": "Rate Name",
      "price_breakdown": "Price Breakdown",
      "subtotal": "Subtotal",
      "service_charge": "Service charge",
      "total": "Total"
    },
    "Reservations": {
      "reservations": "Reservations",
      "attrs": {
        "search_reservations": "Search reservations..."
      },
      "cancelled": "Cancelled",
      "pending": "Pending",
      "date_created": "Date created",
      "pnr": "PNR",
      "checkin_date": "Check-in Date",
      "checkout_date": "Check-out Date",
      "main_guest": "Main Guest",
      "guests": "Guests"
    },
    "Rooms": {
      "rooms": "Rooms",
      "attrs": {
        "search_rooms": "Search rooms..."
      },
      "room_category": "Room Category",
      "no_image": "No image",
      "edit": "Edit",
      "manage_images": "Manage Images",
      "delete": "Delete"
    }
  }
}
